export default {
	id: 'SIMPLE_PREMIUM_COMM_1M_49_99_6M_20',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_1m_49_99_6m_20_usd',
			EUR: 'simple_premium_comm_1m_49_99_6m_20_eur',
			GBP: 'simple_premium_comm_1m_49_99_6m_20_gbp',
			AUD: 'simple_premium_comm_1m_83_3_6m_30_aud',
			CAD: 'simple_premium_comm_1m_83_3_6m_30_cad',
			DKK: 'simple_premium_comm_1m_430_6m_165_dkk',
			NOK: 'simple_premium_comm_1m_665_6m_265_nok',
			SEK: 'simple_premium_comm_1m_665_6m_265_sek',
			MXN: 'simple_premium_comm_1m_829_6m_329_mxn',
			TRY: 'simple_premium_comm_1m_1665_6m_665_try',
			ARS: 'simple_premium_comm_1m_66660_6m_26670_ars',
			COP: 'simple_premium_comm_1m_200010_6m_80020_cop',
			CLP: 'simple_premium_comm_1m_49990_6m_20000_clp',
		},
		primer: 'prd_iad5TqWWFLhl',
	},
	model: {
		commitment_period: 6,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 20,
			EUR: 20,
			GBP: 20,
			AUD: 30,
			CAD: 30,
			DKK: 165,
			NOK: 265,
			SEK: 265,
			MXN: 329,
			TRY: 665,
			ARS: 26670,
			COP: 80020,
			CLP: 20000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49.99,
			EUR: 49.99,
			GBP: 49.99,
			AUD: 83.3,
			CAD: 83.3,
			DKK: 430,
			NOK: 665,
			SEK: 665,
			MXN: 829,
			TRY: 1665,
			ARS: 66660,
			COP: 200010,
			CLP: 49990,
		},
	},
}
